import { getCategoryMonthDrawOrderList } from '@/api/index.js';
export default {
  props: ["show"],
  emits: ['show'],
  name: 'popup-chose-order',
  data() {
    return {
      selected: 0,
      page: 1,
      is_next: true,
      loading: false,
      finished: false,
      orderList: [],
      scrollContainer: null
    };
  },
  computed: {
    show_pop: {
      get() {
        return this.show;
      },
      set() {}
    }
  },
  methods: {
    open() {
      this.selected = 0;
      this.page = 1;
      this.orderList = [];
      this.getOrderList();
    },
    closePopup() {
      this.$emit('update:show', false);
    },
    // 触底时加载更多
    onLoad() {
      setTimeout(() => {
        if (!this.is_next) return;
        this.getOrderList();
      }, 1000);
    },
    getOrderList() {
      getCategoryMonthDrawOrderList({
        page: this.page,
        page_size: 20
      }).then(res => {
        this.loading = false;
        if (res.status === 0) {
          this.orderList = [...this.orderList, ...res.data.list];
          this.is_next = res.data.is_next;
          if (this.is_next) {
            this.page += 1;
          } else {
            this.finished = true;
          }
        } else {
          this.finished = true;
        }
      }).catch(err => {
        console.error(err);
      });
    },
    sub() {
      this.closePopup();
      this.$emit('sub', this.orderList[this.selected]);
    }
  }
};